export function getDayfromDate(incomingdate) {
    let date = new Date(incomingdate);
    let day = date.getDate(); // Get the day of the month
    return day < 10 ? '0' + day : '' + day; // Format it to have two digits
  }